var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground4K(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2560px",
    height: "1560px",
    viewBox: "0 0 2560 1560",
    enableBackground: "new 0 0 2560 1560",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.996,
    y: 5,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    width: 2558.004,
    height: 1560
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#67469C",
    strokeMiterlimit: 10,
    d: "M1280.998,1565c0,0,362.383-976.97,1279.002-1162.121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#67469C",
    strokeMiterlimit: 10,
    d: "M875.76,1567.583c0,0,476.636-511.896,1682.242-608.909"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#67469C",
    strokeMiterlimit: 10,
    d: "M614.854,1565c0,0-38.353-1242.878,1943.147-935.605"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#67469C",
    strokeMiterlimit: 10,
    d: "M0,1555.494c0,0,289.552-713.03,1312.754-196.97 c1023.199,516.062,991.225-158.279,1245.248-187.473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#67469C",
    strokeMiterlimit: 10,
    d: "M2,389.442c0,0,289.552-713.03,1312.754-196.969 C2337.953,708.534,2305.979,34.193,2560.002,5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground4K);
export default __webpack_public_path__ + "static/media/background-4k.5ab52d6b4c8e4b5b029fa91cfdff2b27.svg";
export { ForwardRef as ReactComponent };